import axios from "axios";
import html2pdf from "html2pdf.js";

axios.defaults.timeout = 10000;

const sendWhatsapp = async (link, to) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Sleekflow-Api-Key": "tpVZ8ME7TwQEIyPNh1evp9V1XDU2cSzhKVO9CykMpMg",
  };

  try {
    const results = await axios.post(
      "https://api.sleekflow.io/api/message/send/json",
      {
        channel: "whatsappcloudapi",
        from: "85259441416",
        to,
        messageType: "template",
        extendedMessage: {
          whatsappCloudApiTemplateMessageObject: {
            language: "zh_HK",
            templateName: "ai_report_cta",
            components: [
              {
                type: "button",
                sub_type: "url",
                index: 0,
                parameters: [
                  {
                    type: "text",
                    text: link,
                  },
                ],
              },
            ],
          },
        },
      },
      { headers: headers }
    );
    return "success";
  } catch (err) {
    if (err.response) {
      if (err.response.data.code == 400 && err.response.data.message == "Invalid phone number") {
        return "invalid_phone_number";
      }
      return "template_error";
    }
    return "timeout_error";
  }
};

const sendEmail = async (dev, email, healthReport, emailTemplate, source) => {
  try {
    const devURL = "https://aws-backend.panoptic.ai/email/dev";
    const prodURL = "https://aws-backend.panoptic.ai/email";

    // const url = devURL;
    const url = dev ? devURL : prodURL;

    const body = {
      type: "attachment",
      params: {
        Recipients: email,
        EmailContent: emailTemplate.emailContent,
        EmailSubject: emailTemplate.emailSubject,
        FileName: emailTemplate.fileName,
        Attachments: healthReport,
        Source: source,
      },
    };

    const response = await axios.post(
      url,
      { ...body },
      { headers: { "Content-Type": "application/json", "X-Api-Key": "5MJoAQeSyOazZmSvKyyro45IfnUryvIh4ekOXYax" } }
    );

    if (response.status != 200) {
      throw new Error(response.statusText);
    }

    return "success";
  } catch (e) {
    console.error(e);
    return "failed";
  }
};

const exportReport = (callback, download = false, isAndroidWeChat = false) => {
  return new Promise((resolve, reject) => {
    let reportElement = document.getElementById("report");

    if (!reportElement) {
      reject();
    }

    var opt = {
      filename: "AI Personalized Drink Report.pdf",
      image: { type: "jpeg", quality: 1 },
      jsPDF: { unit: "mm", format: "a5", orientation: "portrait" },
      autoPaging: "text", // Crucial for handling text flow across pages
      html2canvas: {
        allowTaint: true,
        letterRendering: true,
        logging: false,
        scale: 2, // Adjust the scale to fit content
      },
    };

    const pdf = html2pdf().set(opt).from(reportElement);
    if (download) {
      if (isAndroidWeChat) {
        pdf.outputImg().then(async (imgReport) => {
          callback(imgReport);
          resolve();
        });
      } else {
        pdf.save();
        resolve();
      }
    } else {
      // for debug (open pdf in new tab)
      // .output("dataurlnewwindow");

      // for generating pdf
      pdf.outputPdf().then(async (pdfReport) => {
        callback(pdfReport);
      });
    }
  });
};

const checkFollowStatus = async (code) => {
  let accessTokenApi =
    "https://api.weixin.qq.com/sns/oauth2/access_token?appid=APPID&secret=SECRET&code=CODE&grant_type=authorization_code";
  accessTokenApi = accessTokenApi.replace("CODE", code);
  try {
    const response = await axios.post(accessTokenApi);
    return response.data.openId;
  } catch (e) {
    console.error(e);
  }
};

export default { sendEmail, sendWhatsapp, exportReport, checkFollowStatus };
